import { useQuietMode } from './QuietModeProvider'
import { useDopaWidget } from './DopaWidgetProvider'

interface QuietModeToggleProps {
  className?: string
}

const QuietModeToggle: React.FC<QuietModeToggleProps> = ({ className = '' }) => {
  const { isQuietMode, toggleQuietMode, isLowStimMode, toggleLowStimMode } = useQuietMode()
  const { isWidgetEnabled, toggleWidget } = useDopaWidget()

  return (
    <div className={`space-y-3 sm:space-y-4 ${className}`}>
      {/* Quiet Mode Toggle */}
      <div className="flex items-center justify-between p-3 sm:p-4 bg-sage-50/40 rounded-2xl border border-sage-100/30">
        <div className="flex-1 pr-2">
          <h3 className="text-sage-600 font-light text-xs sm:text-sm mb-1">Quiet Please</h3>
          <p className="text-sage-500 text-xs font-light leading-relaxed">
            Reduces text and visual cues for a calmer experience
          </p>
        </div>
        <button
          onClick={toggleQuietMode}
          className={`relative inline-flex h-5 sm:h-6 w-10 sm:w-11 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-sage-200 focus:ring-offset-2 ${
            isQuietMode ? 'bg-sage-300' : 'bg-sage-100'
          }`}
        >
          <span
            className={`inline-block h-3 sm:h-4 w-3 sm:w-4 transform rounded-full bg-white transition-transform duration-300 ${
              isQuietMode ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>

      {/* Low Stim Mode Toggle */}
      <div className="flex items-center justify-between p-3 sm:p-4 bg-mint-50/40 rounded-2xl border border-mint-100/30">
        <div className="flex-1 pr-2">
          <h3 className="text-mint-600 font-light text-xs sm:text-sm mb-1">Quiet Space Mode</h3>
          <p className="text-mint-500 text-xs font-light leading-relaxed">
            Bigger buttons, extra spacing, minimal animations
          </p>
        </div>
        <button
          onClick={toggleLowStimMode}
          className={`relative inline-flex h-5 sm:h-6 w-10 sm:w-11 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-mint-200 focus:ring-offset-2 ${
            isLowStimMode ? 'bg-mint-300' : 'bg-mint-100'
          }`}
        >
          <span
            className={`inline-block h-3 sm:h-4 w-3 sm:w-4 transform rounded-full bg-white transition-transform duration-300 ${
              isLowStimMode ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>

      {/* Dopa Widget Toggle */}
      <div className="flex items-center justify-between p-3 sm:p-4 bg-peach-50/40 rounded-2xl border border-peach-100/30">
        <div className="flex-1 pr-2">
          <h3 className="text-peach-600 font-light text-xs sm:text-sm mb-1">Floating Dopa Support</h3>
          <p className="text-peach-500 text-xs font-light leading-relaxed">
            Always-available support bubble in bottom corner
          </p>
        </div>
        <button
          onClick={toggleWidget}
          className={`relative inline-flex h-5 sm:h-6 w-10 sm:w-11 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-peach-200 focus:ring-offset-2 ${
            isWidgetEnabled ? 'bg-peach-300' : 'bg-peach-100'
          }`}
        >
          <span
            className={`inline-block h-3 sm:h-4 w-3 sm:w-4 transform rounded-full bg-white transition-transform duration-300 ${
              isWidgetEnabled ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  )
}

export default QuietModeToggle